var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.625 0.125L6.875 0.125C6.96121 0.124924 7.04658 0.143855 7.12625 0.180712C7.20591 0.217568 7.27831 0.271629 7.3393 0.339805L11.7403 5.26563L15.791 5.26563L14.2857 3.58207C14.1626 3.44427 14.0934 3.25738 14.0934 3.0625C14.0934 2.86762 14.1626 2.68073 14.2857 2.54293C14.4088 2.40513 14.5759 2.32772 14.75 2.32772C14.9241 2.32772 15.0912 2.40513 15.2143 2.54293L17.8393 5.48043C17.9003 5.54863 17.9487 5.62963 17.9817 5.71878C18.0148 5.80793 18.0318 5.90349 18.0318 6C18.0318 6.09651 18.0148 6.19207 17.9817 6.28122C17.9487 6.37037 17.9003 6.45137 17.8393 6.51957L15.2143 9.45707C15.0912 9.59487 14.9241 9.67228 14.75 9.67228C14.5759 9.67228 14.4088 9.59487 14.2857 9.45707C14.1626 9.31927 14.0934 9.13238 14.0934 8.9375C14.0934 8.74262 14.1626 8.55573 14.2857 8.41793L15.791 6.73437L11.7403 6.73437L7.3393 11.6602C7.27831 11.7284 7.20591 11.7824 7.12625 11.8193C7.04658 11.8561 6.96121 11.8751 6.875 11.875L1.625 11.875C1.45095 11.875 1.28403 11.7976 1.16096 11.6599C1.03789 11.5222 0.96875 11.3354 0.96875 11.1406C0.96875 10.9459 1.03789 10.7591 1.16096 10.6213C1.28403 10.4836 1.45095 10.4062 1.625 10.4062L6.60348 10.4062L10.541 6L6.60348 1.59375L1.625 1.59375C1.45095 1.59375 1.28403 1.51638 1.16096 1.37866C1.03789 1.24094 0.96875 1.05414 0.96875 0.859375C0.96875 0.664607 1.03789 0.477815 1.16096 0.340093C1.28403 0.202371 1.45095 0.125 1.625 0.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 256",
    d: "M2.28125 6L11.4688 6",
    stroke: "#F4F4F4",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/GroupIcon.cf643e0e5c9d7fa35c297a55c0296eef.svg";
export { ForwardRef as ReactComponent };